/**
 * OptimizedImage – simple image wrapper for website-preview pages.
 * Accepts src, alt, className and passes through to img.
 */

import React from "react";

export interface OptimizedImageProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  className?: string;
  width?: number | string;
  height?: number | string;
  fill?: boolean;
  priority?: boolean;
  /** Next.js compat – ignored in this app */
  unoptimized?: boolean;
}

export default function OptimizedImage({
  src,
  alt,
  className,
  width,
  height,
  fill,
  priority,
  unoptimized: _unoptimized,
  ...rest
}: OptimizedImageProps) {
  const style: React.CSSProperties = fill
    ? { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }
    : {};

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      width={width as number | undefined}
      height={height as number | undefined}
      style={Object.keys(style).length ? style : undefined}
      loading="lazy"
      {...rest}
    />
  );
}
